import React from 'react';
import Icon from '../../../components/AppIcon';

const LineItemsBreakdown = ({ products }) => {
  const items = products || [];
  const subtotal = items?.reduce((sum, item) => sum + (parseFloat(item?.price || 0) * parseInt(item?.quantity || 1)), 0);

  if (items?.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="Package" size={18} color="var(--color-primary)" />
          <h3 className="text-base font-bold text-gray-900">Products &amp; Services</h3>
        </div>
        <p className="text-sm text-gray-500 text-center py-4">No line items specified for this service.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-2">
        <Icon name="Package" size={18} color="var(--color-primary)" />
        <h3 className="text-base font-bold text-gray-900">Products &amp; Services</h3>
        <span className="ml-auto text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">{items?.length} item{items?.length !== 1 ? 's' : ''}</span>
      </div>

      {/* Desktop Table */}
      <div className="hidden sm:block overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50">
              <th className="px-6 py-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wide">Item</th>
              <th className="px-4 py-3 text-center text-xs font-semibold text-gray-500 uppercase tracking-wide">Qty</th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wide">Unit Price</th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-gray-500 uppercase tracking-wide">Total</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {items?.map((item, idx) => (
              <tr key={item?.id || idx} className="hover:bg-gray-50/50 transition-colors">
                <td className="px-6 py-4">
                  <p className="text-sm font-medium text-gray-900">{item?.name || 'Service Item'}</p>
                  {item?.description && <p className="text-xs text-gray-500 mt-0.5">{item?.description}</p>}
                </td>
                <td className="px-4 py-4 text-center">
                  <span className="text-sm text-gray-700 bg-gray-100 px-2.5 py-1 rounded-md font-medium">{item?.quantity || 1}</span>
                </td>
                <td className="px-4 py-4 text-right">
                  <span className="text-sm text-gray-700">${parseFloat(item?.price || 0)?.toFixed(2)}</span>
                </td>
                <td className="px-6 py-4 text-right">
                  <span className="text-sm font-semibold text-gray-900">
                    ${(parseFloat(item?.price || 0) * parseInt(item?.quantity || 1))?.toFixed(2)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="sm:hidden divide-y divide-gray-100">
        {items?.map((item, idx) => (
          <div key={item?.id || idx} className="px-4 py-4">
            <div className="flex justify-between items-start">
              <div className="flex-1 mr-4">
                <p className="text-sm font-medium text-gray-900">{item?.name || 'Service Item'}</p>
                {item?.description && <p className="text-xs text-gray-500 mt-0.5">{item?.description}</p>}
              </div>
              <p className="text-sm font-bold text-gray-900">
                ${(parseFloat(item?.price || 0) * parseInt(item?.quantity || 1))?.toFixed(2)}
              </p>
            </div>
            <div className="flex items-center gap-4 mt-2">
              <span className="text-xs text-gray-500">Qty: <span className="font-medium text-gray-700">{item?.quantity || 1}</span></span>
              <span className="text-xs text-gray-500">Unit: <span className="font-medium text-gray-700">${parseFloat(item?.price || 0)?.toFixed(2)}</span></span>
            </div>
          </div>
        ))}
      </div>

      {/* Total */}
      <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold text-gray-700">Estimated Total</span>
          <div className="text-right">
            <span className="text-xl font-bold text-primary">${subtotal?.toFixed(2)}</span>
            <p className="text-xs text-gray-500 mt-0.5">Taxes and fees may apply</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LineItemsBreakdown;
